import {Link} from "react-router-dom"
import {useTranslate} from "@refinedev/core"
import {DeleteButton} from "@refinedev/antd"
import {Card, Row, Space} from "antd"
import {EditOutlined, EyeOutlined} from "@ant-design/icons"
import IActivity from "../../interfaces/IActivity"
import IClient from "../../interfaces/IClient"
import IAuthentication from "../../interfaces/IAuthentication"
import IType from "../../interfaces/IType"
import {Custom} from "../../utils/refineUtils"

interface IProps {
    activity: IActivity,
    authentications: IAuthentication[],
    clients: IClient[],
    types: IType[]
}

export default function ActivityCard(props: IProps) {
    const translate = useTranslate()
    return (
        <Card
            key={props.activity.id}
            type="inner"
            title={props?.activity?.title}
            actions={[
                <Link to={`./show/${props?.activity?.id}`}><EyeOutlined/></Link>,
                <Link to={`./edit/${props?.activity?.id}`}><EditOutlined/></Link>,
                <DeleteButton size="small"
                              resource="activity"
                              confirmTitle={translate('buttonsProps.delete.confirmTitle')}
                              confirmOkText={translate('buttonsProps.delete.confirmOkText')}
                              confirmCancelText={translate('buttonsProps.delete.confirmCancelText')}
                              recordItemId={props?.activity?.id}
                              hideText={true}/>
            ]}>
            <Space direction="vertical" size="small" style={{width: "100%"}}>
                <Custom.IconInfo icon="user" label="activity.author" value={props?.activity?.author}/>
                <Custom.IconInfo icon="clock-circle" label="activity.duration" value={Custom.formate(props?.activity?.duration, translate('activity.noDuration'))}/>
                <Custom.IconInfo icon="crown" label="activity.clients"/>
                {props?.activity?.clients.map((item, index) =>
                    <Custom.ClientInfo client={props.clients?.find(c => c.id === item.id) as IClient} key={item.id}/>
                )}
                {props?.activity?.clients?.length === 0 && <Row>{translate('activity.noClient')}</Row>}
                <Custom.IconInfo icon="login" label="activity.authentications"/>
                {props?.activity?.authentications.map((item) => {
                    const auth = props.authentications.find(auth => auth.id === item)
                    const type = props.types.find(type => type.id === auth?.type)
                    return auth && type && item && <Custom.AuthInfo auth={auth} type={type} key={item}/>
                })}
                {props?.activity?.authentications?.length === 0 && <Row>{translate('activity.noAuthentication')}</Row>}
                <Custom.IconInfo icon="calendar" label="activity.instances" value={'' + props?.activity?.instances?.length ?? 0}/>
            </Space>
        </Card>
    )
}